import { useCallback, useState } from "react";
import Layout from "components/layout/Layout";
import { Box, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import PageTitle from "utils/PageTitle";
import PrecisionGuidanceSurvey from "../../sharedComponents/surveys/PrecisionGuidanceSurvey";
import GettingStartedSurveyExitConfirmationModal from "components/v3/sharedComponents/modals/GettingStartedSurveyExitConfirmationModal";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import Translate from "translate/Translate";
import { trackSurveyAbandonAttempted } from "analytics";

const PrecisionGuidanceSurveyPage = (): React.ReactElement => {
  const [exitConfirmationModalOpen, setExitConfirmationModalOpen] = useState<
    boolean
  >(false);

  const handleExitClick = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "precision-guidance-survey",
      workflow: "precision_guidance_survey",
      action: "opened_exit_modal"
    });
    setExitConfirmationModalOpen(true);
  }, [setExitConfirmationModalOpen]);

  PageTitle("Precision guidance survey");

  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, #F2F7FB 0%, rgba(242, 247, 251, 0.00) 62.6%)",
        minHeight: "100%"
      }}
    >
      <Layout
        goBackPath={PATHS.LANDING_PAGE}
        goBackTitle="Dashboard"
        hasNotHeader={true}
        hasNoFooter={true}
      >
        <Box
          sx={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            margin: "auto",
            maxWidth: "900px",
            padding: {
              xs: "0 15px 0 15px",
              sm: "0 32px 0 32px",
              lg: "0 0 0 0px"
            },
            width: "100%"
          }}
        >
          <PrecisionGuidanceSurvey />
        </Box>
      </Layout>
      <Box
        sx={{
          position: "absolute",
          left: {
            xs: "24px",
            sm: "28px",
            lg: "64px"
          },
          top: "38px"
        }}
      >
        <Box
          onClick={handleExitClick}
          sx={{
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            gap: {
              xs: "4px",
              lg: "12px"
            }
          }}
        >
          <ArrowBack
            sx={{
              color: COLORS.DARK_GRAY,
              height: "20px",
              width: "20px"
            }}
          />
          <Typography variant="body_strong_dark_gray">
            <Translate text="Exit" />
          </Typography>
        </Box>
      </Box>
      <GettingStartedSurveyExitConfirmationModal
        isOpen={exitConfirmationModalOpen}
        onCloseModal={() => {
          trackSurveyAbandonAttempted({
            surveyId: "precision-guidance-survey",
            workflow: "precision_guidance_survey",
            action: "cancelled_exit"
          });
          setExitConfirmationModalOpen(false);
        }}
      />
    </Box>
  );
};

export default PrecisionGuidanceSurveyPage;
